import { style } from '@vanilla-extract/css';

export const spacerElement = style({
  position: 'relative',
  margin: 'var(--margin)',
});
